import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Icon,
  WEATHER_SUN_FILLED,
  WEATHER_MOON_NIGHT_FILLED,
} from '@bwoty-web/styleguide';
import './climateWeatherNugget.scss';

const ClimateWeatherNugget = ({ month, day, night, active, onClick }) => {
  const monthClasses = classNames('gw-weather-month', {
    'gw-weather-month--active': active,
  });

  const dayTempClasses = classNames('gw-weather-month__degree', {
    hidden: !day,
  });

  const nightTempClasses = classNames('gw-weather-month__degree', {
    hidden: !night,
  });

  const renderDegrees = (value, classes) => {
    if (value === undefined || value === null) {
      return <span className="gw-weather-month__fallback">-</span>;
    }
    return (
      <>
        {value}
        <span className={classes}>°</span>
      </>
    );
  };

  return (
    <button type="button" className={monthClasses} onClick={onClick}>
      <h4 className="gw-weather-month__name">{month}</h4>
      <div className="gw-weather-month__temperatures-wrapper">
        <span className="gw-weather-month__temperature gw-weather-month__temperature--day">
          <Icon
            className="gw-weather-month__sun-icon"
            path={WEATHER_SUN_FILLED}
            size="s"
            sizeMobile="xs"
            aria-hidden="true"
          />
          <div>{renderDegrees(day, dayTempClasses)}</div>
        </span>
        <span className="gw-weather-month__temperature gw-weather-month__temperature--night">
          <Icon
            className="gw-weather-month__night-icon"
            path={WEATHER_MOON_NIGHT_FILLED}
            size="s"
            sizeMobile="xs"
            aria-hidden="true"
          />
          <div>{renderDegrees(night, nightTempClasses)}</div>
        </span>
      </div>
    </button>
  );
};

ClimateWeatherNugget.propTypes = {
  active: PropTypes.bool,
  month: PropTypes.string.isRequired,
  day: PropTypes.number,
  night: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

ClimateWeatherNugget.defaultProps = {
  active: false,
  day: '-',
  night: '-',
};

export default ClimateWeatherNugget;
